export const CONVERSATION_DIRECTION_INBOUND = 'inbound';
export const CONVERSATION_DIRECTION_OUTBOUND = 'outbound';
export const CONVERSATION_DIRECTION_BOTH = 'internal';
export const CONVERSATION_STATUS_NONE = 'closed';
export const CONVERSATION_STATUS_ACTIVE = 'open';
export const CONVERSATION_STATUS_PENDING = 'pending';
export const CONVERSATION_STATUS_AWAITING_PENDING = 'awaitingpending';
